import React, { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';
import { LatteButton } from '../common';

const MobileOnboardingGuide = ({ 
  isActive, 
  onComplete, 
  onSkip,
  steps = []
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    setCurrentX(e.touches[0].clientX);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    setCurrentX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (!isDragging) return;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    
    if (Math.abs(diffX) > 80) {
      if (diffX > 0) {
        if (currentStep < steps.length - 1) {
          handleNext();
        }
      } else if (diffX < 0 && currentStep > 0) {
        handlePrevious();
      }
    }
    
    setCurrentX(0);
    setIsDragging(false);
  };

  if (!isActive || steps.length === 0) {
    return null;
  }

  const getTranslateX = () => {
    if (isDragging) {
      return -currentStep * 100 + ((currentX - startX) / window.innerWidth * 100);
    }
    return -currentStep * 100;
  };

  return (
    <div className="mobile-onboarding-overlay">
      <div className="mobile-onboarding-wrapper">
        <button
          onClick={onSkip}
          className="mobile-onboarding-skip"
          aria-label="건너뛰기"
        >
          <X className="w-5 h-5" />
        </button>
        
        <div 
          ref={containerRef}
          className="mobile-onboarding-container"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div 
            className="mobile-onboarding-cards"
            style={{
              transform: `translateX(${getTranslateX()}%)`,
              transition: isDragging ? 'none' : 'transform 0.3s ease-out'
            }}
          >
            {steps.map((step, index) => (
              <div key={index} className="mobile-onboarding-card">
                <div className="card-illustration">
                  <div className="illustration-circle">
                    <span className="illustration-icon">{step.icon}</span>
                  </div>
                </div>
                <div className="card-content">
                  <h3 className="card-title">{step.title}</h3>
                  <p className="card-description">{step.description}</p>
                  {step.tip && (
                    <div className="card-tip">
                      <p className="tip-text">{step.tip}</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mobile-onboarding-footer">
          <div className="mobile-pagination">
            {steps.map((_, index) => (
              <button
                key={index}
                className={`pagination-dot ${index === currentStep ? 'active' : ''}`}
                onClick={() => setCurrentStep(index)}
                aria-label={`${index + 1}번째 슬라이드로 이동`}
              />
            ))}
          </div>
          
          {currentStep === steps.length - 1 && (
            <LatteButton
              onClick={onComplete}
              size="md"
              className="mobile-start-button"
            >
              시작하기
            </LatteButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileOnboardingGuide;